import React from 'react'
import styled from 'styled-components'

import { media, Grid } from '../../utils/style'

const TagList = styled.ul`
  padding: 0;
  margin: 0;

  span {
    text-decoration: none;
    text-transform: uppercase;
    font-weight: bold;
    line-height: 1.74;
    font-size: 13px;
    color: ${(props) => props.theme.colors.grey_light};
    display: inline-block;
    border: 2px ${(props) => props.theme.colors.grey_light_op30} solid;
    padding: 3px 12px;
    border-radius: 10px;
    ${media.LargeScreenUp`
      padding: 7px 25px;
      border-radius: 15px;
    `};
    transition: border-color 3s ${(props) => props.theme.ease.ease_out_circ},
      color 0.3s ${(props) => props.theme.ease.ease_out_expo};

    &:hover {
      border-color: ${(props) => props.theme.colors.grey_light};
      color: ${(props) => props.theme.colors.grey_op80};
    }
  }
`

const Tag = styled(Grid)`
  list-style: none;
  display: inline-block;
`

export default function Tags({ list = [] }) {
  return (
    <TagList>
      {list.map((tag) => (
        <Tag as="li" key={tag} mr={15}>
          <span>{tag}</span>
        </Tag>
      ))}
    </TagList>
  )
}
